<template>
  <Teleport to="body">
    <Transition
      appear
      enter-active-class="tw:transition-transform tw:duration-300 tw:ease-out"
      enter-from-class="tw:translate-x-full"
      leave-active-class="tw:transition-transform tw:duration-300 tw:ease-out"
      leave-to-class="tw:translate-x-full"
    >
      <div
        v-if="open"
        :class="`${$options.name}`"
        :data-e-ga-id="uniqueId"
        :style="`max-width: calc(100vw - 4rem); width: ${width / 16}rem; max-height: ${
          maxHeight / 16
        }rem; bottom: 2rem; right: 2rem; z-index: ${index};`"
        class="tw:fixed tw:bg-white tw:rounded-lg tw:border-none tw:p-6 tw:flex tw:flex-col tw:gap-2 tw:overflow-auto"
        role="dialog"
        style="box-shadow: 4px 4px 24px rgba(0, 0, 0, 0.22)"
        v-bind="$attrs"
      >
        <EdroneButtonIcon
          v-if="showCloseIcon"
          :class="`${$options.name}__close-icon`"
          :disabled="false"
          :unique-id="uniqueId + '-slider-close-icon'"
          class="tw:absolute tw:right-4 tw:top-4 tw:!text-default-600 tw:!text-xl"
          size="small"
          type="plain"
          @click="$emit('close')"
        >
          <font-awesome-icon icon="fa-light fa-xmark" />
        </EdroneButtonIcon>
        <p v-if="$slots.title" class="tw:w-[calc(100%_-_22px)] tw:heading-2">
          <slot name="title"></slot>
        </p>
        <slot></slot>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent, onMounted, watch } from "vue";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";

export default defineComponent({
  name: "EdroneSlider",
  components: {
    EdroneButtonIcon,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    closeOnEscKeyPress: {
      type: Boolean,
      required: false,
      default: true,
    },
    showCloseIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    width: {
      type: [Number],
      required: false,
      default: 400,
    },
    maxHeight: {
      type: [Number],
      required: false,
      default: 600,
    },
    uniqueId: {
      type: String,
      required: false,
    },
    index: {
      type: Number,
      required: false,
      default: 40999,
    },
  },
  emits: {
    close: () => true,
  },
  setup(props, ctx) {
    onMounted(() => {
      window.addEventListener("keydown", onEscKeyPress);
    });

    watch(props, (newProps) => {
      if (newProps.open && props.closeOnEscKeyPress) {
        window.addEventListener("keydown", onEscKeyPress);
      } else {
        window.removeEventListener("keydown", onEscKeyPress);
      }
    });

    function onEscKeyPress(e: KeyboardEvent) {
      if (e.key === "Escape") {
        ctx.emit("close");
      }
    }

    return {};
  },
});
</script>
